export const calculateChangeRates = (tarihselFiyatBilgileri) => {
  if (!tarihselFiyatBilgileri || tarihselFiyatBilgileri.length === 0)
    return null;

  const fiyatlar = tarihselFiyatBilgileri.map((item) => ({
    tarih: new Date(item.Date), // Tarih bilgisini Date objesine çevir
    fiyat: item.Close,
  }));

  // Tarihe göre sırala (en eski tarih en başta)
  fiyatlar.sort((a, b) => a.tarih - b.tarih);

  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const oneMonthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const threeMonthsAgo = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
  const oneYearAgo = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
  const twoYearsAgo = new Date(now.getTime() - 2 * 365 * 24 * 60 * 60 * 1000);
  const fiveYearsAgo = new Date(now.getTime() - 5 * 365 * 24 * 60 * 60 * 1000);

  const getChangeRate = (startDate) => {
    const filteredFiyatlar = fiyatlar.filter((item) => item.tarih >= startDate);
    if (filteredFiyatlar.length === 0) return null;

    const ilkFiyat = filteredFiyatlar[0].fiyat;
    const sonFiyat = filteredFiyatlar[filteredFiyatlar.length - 1].fiyat;
    return ((sonFiyat - ilkFiyat) / ilkFiyat) * 100;
  };

  return {
    "5 Yıllık": getChangeRate(fiveYearsAgo)?.toFixed(2) || "",
    "2 Yıllık": getChangeRate(twoYearsAgo)?.toFixed(2) || "",
    "1 Yıllık": getChangeRate(oneYearAgo)?.toFixed(2) || "",
    "3 Aylık": getChangeRate(threeMonthsAgo)?.toFixed(2) || "",
    Aylık: getChangeRate(oneMonthAgo)?.toFixed(2) || "",
    Haftalık: getChangeRate(oneWeekAgo)?.toFixed(2) || "",
  };
};
